export default "__VITE_ASSET__B4PrAK8W__"